// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProductSale_pageContainer__OG2ax","fromProdPage":"ProductSale_fromProdPage__jqlVh","footer":"ProductSale_footer__8yfef"};